import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Overview from '../components/Overview';
import Agents from '../components/Agents';
import Traces from '../components/Traces';
import Monitoring from '../components/Monitoring';
import SimulationLab from '../components/SimulationLab';
import PromptRegistry from '../components/PromptRegistry';
import Governance from '../components/Governance';
import QualityDashboard from '../components/QualityDashboard';
import Vault from '../components/Vault';
import Settings from '../components/Settings';

const NAV_ITEMS = [
  { key: 'overview',    label: 'Overview',   icon: 'grid',      section: 'Monitor' },
  { key: 'traces',      label: 'Traces',      icon: 'activity',  section: 'Monitor' },
  { key: 'agents',      label: 'Agents',      icon: 'cpu',       section: 'Monitor' },
  { key: 'activity',    label: 'Activity',    icon: 'list',      section: 'Monitor' },
  { key: 'simulations', label: 'Simulations', icon: 'play',      section: 'Evaluate' },
  { key: 'prompts',     label: 'Prompts',     icon: 'file-text', section: 'Evaluate' },
  { key: 'governance',  label: 'Governance',  icon: 'shield',    section: 'Control' },
  { key: 'quality',     label: 'Quality',     icon: 'bar-chart', section: 'Control' },
  { key: 'vault',       label: 'Key Vault',   icon: 'lock',      section: 'Settings' },
  { key: 'settings',    label: 'Settings',    icon: 'settings',  section: 'Settings' },
];

const ICONS = {
  grid: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>,
  activity: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>,
  cpu: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="4" y="4" width="16" height="16" rx="2"/><rect x="9" y="9" width="6" height="6"/><line x1="9" y1="1" x2="9" y2="4"/><line x1="15" y1="1" x2="15" y2="4"/><line x1="9" y1="20" x2="9" y2="23"/><line x1="15" y1="20" x2="15" y2="23"/><line x1="20" y1="9" x2="23" y2="9"/><line x1="20" y1="14" x2="23" y2="14"/><line x1="1" y1="9" x2="4" y2="9"/><line x1="1" y1="14" x2="4" y2="14"/></svg>,
  list: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>,
  play: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polygon points="5 3 19 12 5 21 5 3"/></svg>,
  'file-text': <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>,
  shield: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
  'bar-chart': <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="12" y1="20" x2="12" y2="10"/><line x1="18" y1="20" x2="18" y2="4"/><line x1="6" y1="20" x2="6" y2="16"/></svg>,
  lock: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>,
  settings: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>,
  logout: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>,
};

const VALID_PAGES = new Set(NAV_ITEMS.map(n => n.key));

function Dashboard({ token, onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  // Derive current page from URL path: /dashboard/traces → "traces"
  const pathSegment = location.pathname.replace(/^\/dashboard\/?/, '') || 'overview';
  const page = VALID_PAGES.has(pathSegment) ? pathSegment : 'overview';

  const handleNav = (key) => {
    navigate('/dashboard/' + key);
    setMobileNavOpen(false);
  };

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };

  const sections = {};
  NAV_ITEMS.forEach(item => {
    if (!sections[item.section]) sections[item.section] = [];
    sections[item.section].push(item);
  });

  const renderPage = () => {
    switch (page) {
      case 'overview':    return <Overview token={token} onNavigate={handleNav} />;
      case 'traces':      return <Traces token={token} />;
      case 'agents':      return <Agents token={token} />;
      case 'activity':    return <Monitoring token={token} />;
      case 'simulations': return <SimulationLab token={token} />;
      case 'prompts':     return <PromptRegistry token={token} />;
      case 'governance':  return <Governance token={token} />;
      case 'quality':     return <QualityDashboard token={token} />;
      case 'vault':       return <Vault token={token} />;
      case 'settings':    return <Settings token={token} />;
      default:            return <Overview token={token} onNavigate={handleNav} />;
    }
  };

  return (
    <div className="app-layout">
      {mobileNavOpen && (
        <div className="sidebar-overlay" onClick={() => setMobileNavOpen(false)} />
      )}

      <nav className={`sidebar${mobileNavOpen ? ' sidebar-open' : ''}`}>
        <div className="sidebar-logo">
          <svg width="28" height="28" viewBox="0 0 32 32" fill="none" style={{ flexShrink: 0, borderRadius: 8 }}>
            <rect width="32" height="32" rx="8" fill="#3b82f6"/>
            <path d="M6 16c0 0 4-6.5 10-6.5S26 16 26 16s-4 6.5-10 6.5S6 16 6 16z"
                  stroke="white" strokeWidth="1.5" fill="none" strokeLinejoin="round"/>
            <circle cx="16" cy="16" r="2.5" fill="white"/>
          </svg>
          <span>Agent Oversight</span>
        </div>

        <div style={{ flex: 1, paddingTop: 8 }}>
          {Object.entries(sections).map(([section, items]) => (
            <div className="sidebar-section" key={section}>
              <div className="sidebar-section-label">{section}</div>
              <ul className="sidebar-nav">
                {items.map(item => (
                  <li key={item.key}>
                    <button
                      className={'sidebar-item' + (page === item.key ? ' active' : '')}
                      onClick={() => handleNav(item.key)}
                    >
                      <span className="sidebar-icon">{ICONS[item.icon]}</span>
                      {item.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="sidebar-footer">
          <button className="sidebar-item" onClick={handleLogout}>
            <span className="sidebar-icon">{ICONS.logout}</span>
            Logout
          </button>
        </div>
      </nav>

      <main className="main-content">
        <div className="mobile-topbar">
          <button className="hamburger-btn" onClick={() => setMobileNavOpen(o => !o)} aria-label="Open navigation">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <line x1="3" y1="6" x2="21" y2="6"/>
              <line x1="3" y1="12" x2="21" y2="12"/>
              <line x1="3" y1="18" x2="21" y2="18"/>
            </svg>
          </button>
          <svg width="22" height="22" viewBox="0 0 32 32" fill="none" style={{ borderRadius: 6, flexShrink: 0 }}>
            <rect width="32" height="32" rx="8" fill="#3b82f6"/>
            <path d="M6 16c0 0 4-6.5 10-6.5S26 16 26 16s-4 6.5-10 6.5S6 16 6 16z" stroke="white" strokeWidth="1.5" fill="none" strokeLinejoin="round"/>
            <circle cx="16" cy="16" r="2.5" fill="white"/>
          </svg>
          <span className="mobile-brand">Agent Oversight</span>
        </div>
        {renderPage()}
      </main>
    </div>
  );
}

export default Dashboard;
